/*!

=========================================================
* Paper Dashboard React - v1.3.1
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useAuth0 } from '@auth0/auth0-react';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, NavLink, useNavigate } from 'react-router-dom';
import { debounce } from 'lodash';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  InputGroup,
  InputGroupText,
  Input,
} from 'reactstrap';
import { LocalStorageService } from '../../common';
import { userInfoSelector } from '../../store/slices/userInfo';
import modelCentralLogo from '../../../images/logo/sidebar_logo.png';
import { Button } from '@mui/material';

const Header = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const [color, setColor] = React.useState('transparent');
  const sidebarToggle = React.useRef();
  const location = useLocation();
  const { userInfo } = useSelector(userInfoSelector);
  const [searchKeyWord, setSearchKeyWord] = useState('');
  const searchInputRef = useRef('');
  const navigate = useNavigate();
  const [showSearchBar, setShowSearchBar] = useState(true);

  const { isAuthenticated, loginWithRedirect, logout, user } = useAuth0();

  const onSearchKeyWordChange = (e) => {
    const value = e.target.value ? e.target.value : '';
    setSearchKeyWord(value);
    searchInputRef.current(value);
  };

  const doSearch = (input) => {
    if (input) {
      navigate('/search', { state: { searchKeyword: input } });
      setSearchKeyWord('');
      searchInputRef.current('');
    }
  };
  const toggle = () => {
    if (isOpen) {
      setColor('transparent');
    } else {
      setColor('dark');
    }
    setIsOpen(!isOpen);
  };
  const dropdownToggle = (e) => {
    const text = e.target.innerText;
    if (text === 'Logout') {
      LocalStorageService.removeItem('toekn');
      LocalStorageService.clear();
      logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      });
    } else if (text === 'Login') {
      loginWithRedirect();
    }
    setDropdownOpen(!dropdownOpen);
  };
  const openSidebar = () => {
    document.documentElement.classList.toggle('nav-open');
    sidebarToggle.current.classList.toggle('toggled');
  };
  // function that adds color dark/transparent to the navbar on resize (this is for the collapse)
  const updateColor = () => {
    if (window.innerWidth < 993 && isOpen) {
      setColor('dark');
    } else {
      setColor('transparent');
    }
  };
  React.useEffect(() => {
    window.addEventListener('resize', updateColor.bind(this));
  });
  React.useEffect(() => {
    if (window.innerWidth < 993 && document.documentElement.className.indexOf('nav-open') !== -1) {
      document.documentElement.classList.toggle('nav-open');
      sidebarToggle.current.classList.toggle('toggled');
    }
    // console.log('location', location);
    if (
      location.pathname === '/search' ||
      location.pathname === '/' ||
      location.pathname === '/about' ||
      location.pathname === '/requestmodel'
    ) {
      setShowSearchBar(false);
    } else {
      setShowSearchBar(false);
    }
  }, [location]);

  useEffect(() => {
    searchInputRef.current = debounce(doSearch, 500);
  }, []);

  return (
    // add or remove classes depending if we are on full-screen-maps page or not
    <Navbar
      color={location.pathname.indexOf('full-screen-maps') !== -1 ? 'dark' : color}
      expand="lg"
      className={
        location.pathname.indexOf('full-screen-maps') !== -1
          ? 'navbar-absolute fixed-top navbar-override-custom'
          : 'navbar-absolute fixed-top ' + (color === 'transparent' ? 'navbar-transparent ' : '')
      }
    >
      <div className="navbar-wrapper">
        <NavbarBrand className="navbar-logo">
          <a className="cursor-pointer" onClick={(e) => navigate('/')}>
            <div className="logo-img">
              <img src={modelCentralLogo} alt="modelCentral-logo" />
            </div>
          </a>
        </NavbarBrand>
      </div>
      <Nav navbar>
        {isAuthenticated && <p className="user-name">{userInfo?.displayName}</p>}
        {!isAuthenticated && (
          <Button onClick={loginWithRedirect} sx={{ paddingRight: '1.1rem' }}>
            Login
          </Button>
        )}
      </Nav>
    </Navbar>
  );
};

export default Header;
